"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _baseWidgetModule = _interopRequireDefault(require("./base-widget.module.scss"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var WidgetChildren = function WidgetChildren(_ref) {
  var _cx;

  var children = _ref.children,
      isEditActive = _ref.isEditActive,
      isBorder = _ref.isBorder;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])(_baseWidgetModule["default"].widgetContent, (_cx = {}, _defineProperty(_cx, _baseWidgetModule["default"].noBorder, !isBorder), _defineProperty(_cx, _baseWidgetModule["default"].editActive, isEditActive), _cx))
  }, children);
};

WidgetChildren.propTypes = {
  children: _propTypes["default"].node,
  isEditActive: _propTypes["default"].bool,
  isBorder: _propTypes["default"].bool
};
WidgetChildren.defaultProps = {
  children: null,
  isEditActive: false,
  isBorder: true
};
var _default = WidgetChildren;
exports["default"] = _default;